import { render, staticRenderFns } from "./inquiry-input.vue?vue&type=template&id=456231ff&scoped=true"
import script from "./inquiry-input.vue?vue&type=script&lang=js"
export * from "./inquiry-input.vue?vue&type=script&lang=js"
import style0 from "./inquiry-input.vue?vue&type=style&index=0&id=456231ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456231ff",
  null
  
)

export default component.exports